<div class="digital-hospital-container">
	<div class="card">
		<div class="card-header">
			<h2 class="title">Status do Serviço</h2>
			<span
				class="status-tag"
				[ngClass]="{
					inactive: !hasDigitalHospital,
					active: hasDigitalHospital,
				}"
			>
				{{ hasDigitalHospital ? 'Ativo' : 'Inativo' }}
			</span>
		</div>
		<p class="description">
			Controle se os beneficiários podem acessar os serviços digitais
		</p>
		<div class="info-box">
			<mat-icon class="icon">info_outline</mat-icon>
			<p class="info-text">
				Quando ativado, todos os beneficiários cadastrados poderão acessar os
				serviços. O processo de ativação pode levar algumas horas para ser
				concluído.
			</p>
		</div>
	</div>

	<button
		mat-flat-button
		color="primary"
		class="action-button"
		(click)="toogleDigitalHospital()"
		[disabled]="isLoading"
	>
		<mat-spinner
			*ngIf="isLoading"
			diameter="20"
			class="button-spinner"
		></mat-spinner>
		<span *ngIf="!isLoading">{{ getButtonText() }}</span>
	</button>
</div>

<ng-template #confirmationDialog>
	<div mat-dialog-title class="dialog-title">
		<mat-icon class="warning-icon">warning_amber</mat-icon>
		<h2>Confirmar Desativação</h2>
	</div>

	<mat-dialog-content class="dialog-content">
		<p>
			Você está prestes a desativar o Hospital Digital. Este processo pode levar
			algumas horas para ser concluído e terá grande impacto no negócio, pois
			todos os beneficiários perderão acesso aos serviços digitais.
		</p>
		<p>Tem certeza de que deseja continuar?</p>
	</mat-dialog-content>

	<mat-dialog-actions align="end" class="dialog-actions">
		<button mat-stroked-button mat-dialog-close>Cancelar</button>
		<button
			mat-flat-button
			color="warn"
			[mat-dialog-close]="true"
			cdkFocusInitial
		>
			Sim, Desativar
		</button>
	</mat-dialog-actions>
</ng-template>
